var _path, _path2, _line, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7257 9.31341L13.9771 10.0144C14.7235 10.2467 15.4359 9.57142 15.2437 8.81374L14.6739 6.56703C14.493 5.85377 13.6297 5.57356 13.0644 6.04462L12.2147 6.75266L11.3159 7.65151C10.7841 8.18333 11.0076 9.08983 11.7257 9.31341Z",
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 9.34173L17.7348 10.0427C16.9885 10.2751 16.2761 9.59974 16.4682 8.84206L17.038 6.59535C17.2189 5.88209 18.0822 5.60188 18.6475 6.07294L19.4972 6.78098L20.396 7.67983C20.9279 8.21165 20.7043 9.11815 19.9862 9.34173Z",
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 11,
    x2: 16,
    y2: 24,
    stroke: "#F1A7A7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H7V16V21C7 22.6569 8.34315 24 10 24H22C23.6569 24 25 22.6569 25 21V16V15H24H8Z",
    stroke: "#DF3030",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H7V14C7 12.3431 8.34315 11 10 11H22C23.6569 11 25 12.3431 25 14V15H24H8Z",
    stroke: "#DF3030",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftSent);
export default __webpack_public_path__ + "static/media/giftSent.486d66b079f74347aed37b4687e89950.svg";
export { ForwardRef as ReactComponent };